<div layout-vertical>
  <rt-heading variant="large-xxx bold">{{ heading() }} </rt-heading>
  <span class="subheading">{{ subheading() }}</span>
</div>
<div class="insights-container">
  @for (card of impactTrackerCards(); track $index) {
    <tlc-churn-flow-insight-card
      [iconName]="card.icon"
      [tooltip]="card.tooltip"
      [value]="card.value"
      [label]="card.label"
      [title]="card.title"
    />
  }
</div>
<div class="impact-logo-container">
  <tlc-churn-flow-tellent-impact-logo />
</div>
